import HolderDID from './HolderDID'
export default HolderDID